export const months = {
  jan: 'Tammikuu',
  feb: 'Helmikuu',
  mar: 'Maaliskuu',
  apr: 'Huhtikuu',
  may: 'Toukokuu',
  jun: 'Kesäkuu',
  jul: 'Heinäkuu',
  aug: 'Elokuu',
  sep: 'Syyskuu',
  okt: 'Lokakuu',
  nov: 'Marraskuu',
  dec: 'Joulukuu',
};

export const weekdays = {
  mon: 'Ma',
  tue: 'Ti',
  wed: 'Ke',
  thu: 'To',
  fri: 'Pe',
  sat: 'La',
  sun: 'Su',
};
